import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { dismissBanner } from 'actions/redux/local_network_access_actions';
import { selectShouldShowLocalNetworkAccessBanner } from 'selectors/local_network_access_selectors';
import LocalNetworkAccessModal from 'components/local_network_access_modal';

const LocalNetworkAccessBanner = () => {
  const dispatch = useDispatch();
  const shouldShow = useSelector((state) =>
    selectShouldShowLocalNetworkAccessBanner(state)
  );
  const [modalVisible, setModalVisible] = useState(false);

  if (!shouldShow) {
    return null;
  }

  const handleDismiss = () => {
    dispatch(dismissBanner());
  };

  const handleOpenModal = () => {
    setModalVisible(true);
  };

  const handleCloseModal = () => {
    setModalVisible(false);
  };

  return (
    <>
      <div
        className="danger text-center notice alert"
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          zIndex: 9999,
        }}
      >
        <div className="notice-message">
          <i className="icon-alert" />
          <span>Local network access is blocked. Printing may not work.</span>
        </div>
        <a className="button default" onClick={handleOpenModal}>
          How to fix
        </a>
        <a className="button default" onClick={handleDismiss}>
          <i className="icon-cancel" />
        </a>
      </div>
      {modalVisible && (
        <LocalNetworkAccessModal
          visible={modalVisible}
          onClose={handleCloseModal}
        />
      )}
    </>
  );
};

export default LocalNetworkAccessBanner;
